module.exports = __webpack_public_path__ + "static/media/h16_dementia.0699060d.webp";